<template>
  <b-container fluid="lg" class="tutor-content">
    <div class="tutor-infomation">
      <div>
        <p>Tuter Name</p>
        <h2 class="tutor-name">{{ tutor && tutor.name }}</h2>
      </div>
      <span class="tutor-info">
        {{ tutor && tutor.hireDate.format('YYYY/MM/DD') }}
        {{ tutor && tutor.id }}
        {{ tutor && tutor.position.name }}
      </span>
      <slot></slot>
    </div>
  </b-container>
</template>

<script lang="ts">
import { Tutor } from '@/store/tutors/types'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class SchedulesTutorInfo extends Vue {
  @Prop() tutor!: Tutor
}
</script>

<style scoped>
  .tutor-content {
    background: #D8D8D8;
    padding:40px 0px;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .tutor-name {
    line-height: 25px;
    font-size:25px;
    margin-bottom:10px;
  }

  .tutor-info {
    padding: 5px 10px;
    border-radius: 20px;
    background: #2E75B5;
    color: #fff;
  }

  .tutor-content p {
    text-align: left;
    margin-bottom: 5px;
  }

  .tutor-infomation {
    text-align: center;
    width: 30%;
  }

</style>
